import {Injectable} from "@angular/core";

import {Page} from "../../src/app/shared/sdk/models/Page";
import {PageApi} from "../../src/app/shared/sdk/services/custom/Page";
import {CostGuide} from "../../src/app/shared/sdk/models/CostGuide";
import {CostGuideApi} from "../../src/app/shared/sdk/services/custom/CostGuide";
import {ZipcodeModificationFactorApi} from "../../src/app/shared/sdk/services/custom/ZipcodeModificationFactor";
import {Observable} from "rxjs/Observable";
import {CategoryApi} from "../../src/app/shared/sdk/services/custom/Category";
const PageUtils = require("./pageutils.js");

import * as _ from "lodash";

@Injectable()
export class CostGuideUtils {

  protected cities =
    [
      'ATLANTA, GA',
      'AUSTIN, TX',
      'BRONX, NY',
      'BROOKLYN, NY',
      'CHICAGO, IL',
      'DENVER, CO',
      'FORT LAUDERDALE, FL',
      'HOUSTON, TX',
      'LAS VEGAS, NV',
      'LOS ANGELES, CA',
      'MIAMI, FL',
      'MINNEAPOLIS, MN',
      'NEW YORK, NY',
      'PHILADELPHIA, PA',
      'PHOENIX, AZ',
      'SAN ANTONIO, TX',
      'SAN DIEGO, CA',
      'SAN JOSE, CA',
      'SEATTLE, WA',
      'WASHINGTON, DC'
    ];

  protected cityModificationFactors = [];

  constructor(protected pageApi: PageApi,
              protected costGuideApi: CostGuideApi,
              protected categoryApi: CategoryApi,
              protected zipcodeModificationFactorApi: ZipcodeModificationFactorApi) {}

  public loadCostGuidesTitlesByGroupAndCategory(): Observable<object> {
    return this.pageApi.find({where: {pageType: 'CostGuide'}, include: {'pageable' : ['category']}})
      .map((pages: any) => { return this.toTitleCategoryUrlList(pages) });
  }

  public loadCostGuide(url: string): Observable<object> {
    return this.pageApi.findOne({where: {url: url}, include: { 'pageable' : ['category']}})
      .map((page: Page) => { return this.composeCostGuidePage(page) });
  }

  public loadZipcodeModificationFactors(costGuide: any): Observable<object> {
    return this.zipcodeModificationFactorApi.find({where: { cityAndState: {inq: this.cities }}})
      .map((zipcodeModificationFactors: any) => {

       let citiesMap = zipcodeModificationFactors.reduce((cities, currentCity) => {

          if(!!cities[currentCity.cityAndState]) {
            cities[currentCity.cityAndState].EquipmentFactor = (cities[currentCity.cityAndState].EquipmentFactor + currentCity.EquipmentFactor) / 2;
            cities[currentCity.cityAndState].LaborFactor = (cities[currentCity.cityAndState].LaborFactor + currentCity.LaborFactor) / 2;
            cities[currentCity.cityAndState].MaterialsFactor = (cities[currentCity.cityAndState].MaterialsFactor + currentCity.MaterialsFactor) / 2;
          }
          else {
            cities[currentCity.cityAndState] = currentCity;
          }

          return cities;

        }, {});

       let returnValue = [];
       for(var cityKey in citiesMap) {

         let cityModificationFactor = citiesMap[cityKey];
         cityModificationFactor.typicalCost = this.applyCostModificationFactorsToMoneyAmounts(costGuide.averagePrice, cityModificationFactor);
         cityModificationFactor.cityAndState = this.changeCityCase(cityModificationFactor.cityAndState);
         returnValue.push(cityModificationFactor);
       }

       return returnValue;

      });
  }

  protected toTitleCategoryUrlList(pages: any) {

    let returnValue = {};

    pages.forEach(page => {

      if (page != null && page.pageType == 'CostGuide' && !!page.pageable) {

        let costGuide = page.pageable;

        if(costGuide.category != null) {
          let pageElements = {
            title: costGuide.title,
            url: '/costs/' + costGuide.seo_id,
          };

          if(!returnValue.hasOwnProperty(costGuide.category.group)) {
            returnValue[costGuide.category.group] = {};
          }
          if (!returnValue[costGuide.category.group].hasOwnProperty(costGuide.category._name)) {
            returnValue[costGuide.category.group][costGuide.category._name] = [];
          }
          returnValue[costGuide.category.group][costGuide.category._name].push(pageElements);
        }
      }

    });

    return returnValue;

  }

  protected composeCostGuidePage(page:Page) {

    if (page != null && page.pageType == 'CostGuide' && !!page.pageable) {

      let costGuide = page.pageable;

      //fix some occurrences within the cost guides content:
      if (!!costGuide.content && costGuide.content.length > 0) {
        costGuide.content = costGuide.content.replace(/http\:\/\/cdn/g, 'https://cdn');
        costGuide.content = costGuide.content.replace(/col-xs-/g, 'col-');
      }

      let ogImageWithProtocol = null; //todo
      let imagesOnContent = PageUtils.getAllImagesOnContent(costGuide.content);
      let embeddedTweetHtml = null; //todo

      let zipcodeModificationFactors = [];
      let averagePrice = this.getPriceFromCostGuidePriceText(costGuide.medium_cost_text);
      let verticalType = costGuide.vertical_type;
      if(typeof verticalType == 'undefined' || verticalType == null) {
        verticalType = 1;
      }

      let costGuideData = {
        id: costGuide.id,
        title: costGuide.title,
        content: costGuide.content,
        costGuideAction: costGuide.cost_action,
        mediumCost: costGuide.medium_cost_text,
        fixrTasks: costGuide.fixr_task_id,
        category: costGuide.fixr_category_id,
        categoryName: !!costGuide.category?costGuide.category._name:'',
        group: (!!costGuide.category && !!costGuide.category.group)?costGuide.category.group:1,
        relatedCostGuides: [],
        cities: zipcodeModificationFactors,
        averagePrice: averagePrice,
        averagePriceDescription: this.getAdditionalPriceInfoFromCostGuidePriceText(costGuide.medium_cost_text),
        lowerPrice: this.getPriceFromCostGuidePriceText(costGuide.low_cost_text),
        lowerPriceDescription: this.getAdditionalPriceInfoFromCostGuidePriceText(costGuide.low_cost_text),
        upperPrice: this.getPriceFromCostGuidePriceText(costGuide.high_cost_text),
        upperPriceDescription: this.getAdditionalPriceInfoFromCostGuidePriceText(costGuide.high_cost_text),
        seoId: costGuide.seo_id,
        costAction: costGuide.cost_action,
        layout: costGuide.layout,
        verticalType: verticalType,
        pricesRangeDescription: costGuide.pricesRangeDescription,
        url: page.url,
      };

      costGuideData['pageMetaTitle'] = this.generateMetaTitle(costGuideData);
      costGuideData['pageMetaDescription'] = this.generateMetaDescription(costGuideData);

      return costGuideData;

    }
    else {
      //redirect to new page...
    }

    return null;

  }

  protected generateMetaTitle(costGuide) {
    var title = '';

    if(!!costGuide.costAction) {
      title = 'Cost ' + costGuide.costAction + ' - Estimates and Prices at Howmuch';
    } else if(!!costGuide.title){
      title = costGuide.title + ' - Estimates and Prices at Howmuch';
    }

    return title;
  }

  protected generateMetaDescription(costGuide) {
    var description = '';

    var isCostAction = false;
    if(!!costGuide.costAction) {
      description = 'Average cost ' + costGuide.costAction;
      isCostAction = true;
    } else {
      description = _.capitalize(costGuide.title.toLowerCase());
    }

    if(description != '') {
      if(!!costGuide.averagePrice) {
        if(isCostAction) {
          description += ' is ';
        } else {
          description += ' are ';
        }
        description += 'about ' + costGuide.averagePrice + ' ' + costGuide.averagePriceDescription;
      } else if(!!costGuide.lowerPrice && !! costGuide.upperPrice) {
        description += ' ranges from ' + costGuide.lowerPrice + ' up to ' + costGuide.upperPrice;
      } else {
        description += ' varies depending on many factors';
      }

      description += '. Find here detailed information about ' + costGuide.title.toLowerCase() + '.';
    }

    return description;
  }

  protected changeCityCase(city) {
    city = city.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
    city = city.replace(/,\s\w{2}/g, function(txt) { return txt.toUpperCase(); });
    return city;
  }

  protected applyCostModificationFactorsToMoneyAmounts(content, cityModificationFactor) {

    var myRegexp = /\$([\d\,\.]*\d+)/g;
    var match = myRegexp.exec(content);
    while (match != null) {
      var matchAmount = match[1];
      var money = parseFloat(matchAmount.replace(',', ''));
      var modificationFactor = cityModificationFactor.LaborFactor;
      money = money + (money * modificationFactor / 100);
      if (match[1].indexOf(".") > -1) {
        content = content.replace(match[1], PageUtils.formatMoney(money, 2));
      }
      else {
        content = content.replace(match[1], PageUtils.formatMoney(money, 0));
      }
      match = myRegexp.exec(content);
    }
    return content;
  }

  protected getAdditionalPriceInfoFromCostGuidePriceText(cost) {
    if(!!cost) {
      return cost.replace(/\$[^ ]*/, '').trim();
    }
    return undefined;
  }

  protected getPriceFromCostGuidePriceText(cost) {
    if (!!cost) {
      var myRegexp = /\$[^ ]*/;
      var match = myRegexp.exec(cost);
      if (!!match) {
        return match.toString();
      }
    }
    return undefined;
  }

  public loadCostGuideBySeoId(seoId: string) {
    return this.costGuideApi.findOne({
      where: {
        seoId: seoId
      },
      include: ['page', 'category'],
    }).map((costGuides: CostGuide[]) => {
      return costGuides.map((costGuide: CostGuide) => {

        let page: Page = costGuide.page;
        costGuide.page = null;
        page.pageable = costGuide;

        return this.composeCostGuidePage(page);
      });
    });
  }

  public loadCostGuideByVertical(vertical: number, total: number) {

    let query = {
      where: {},
      include: ['page', 'category'],
      order: 'created DESC',
      limit: total
    };

    if(vertical == 1) {
      query.where = {
        or: [
          {vertical_type: '1'},
          {vertical_type: null},
          {vertical_type: {exists: false}}
        ]
      };
    } else if (vertical == 2) {
      query.where = {vertical_type: '2'}
    }

    return this.costGuideApi.find(query).map((costGuides: CostGuide[]) => {
      return costGuides.map((costGuide: CostGuide) => {

        let page: Page = costGuide.page;
        costGuide.page = null;
        page.pageable = costGuide;

        return this.composeCostGuidePage(page);
      });
    });
  }

}



// WEBPACK FOOTER //
// ./common/utils/costguideutils.ts